import { render } from "./MenuMobile.vue?vue&type=template&id=6ed7eb82&scoped=true"
const script = {}

import "./MenuMobile.vue?vue&type=style&index=0&id=6ed7eb82&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed7eb82"]])

export default __exports__